import React from 'react'

const CardWrapper = ({ children, text, description, config, link }) => {

  const handleCardClick = (url) => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className='bubble-card-wrapper flex flex-col items-start self-stretch '>
      <div
        className={`bubble-card rounded-[20px] gap-v3-xs w-full ${
          link ? 'group shadow-v3-double cursor-pointer transition-shadow duration-200 hover:shadow-none' : ''
        }`}
        style={{
          backgroundColor: config?.surface_color || '#ffffff',
          '--brand-color': config?.brand_color || 'var(--v3-purple-primary)',
        }}
        onClick={() => link && handleCardClick(link)}
      >
        {children}

        {(text || description) && (
          <div className="flex flex-col gap-v3-xxs items-start self-stretch font-inter-variable p-v3-sm ">
            {text && (
              <h2
                className={`text-sm font-semibold leading-[160%] transition-colors duration-200 ${
                  link ? 'group-hover:!text-[var(--brand-color)]' : ''
                }`}
                style={{
                  color: config?.element_color || 'var(--v3-black-max)',
                  fontFamily: config?.font_name ? `${config.font_name}, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif` : undefined,
                  fontSize: config?.font_size ? `${config.font_size}px` : undefined,
                }}
              >
                {text}
              </h2>
            )}
            {description && (
              <p
                className={`text-sm font-normal leading-5 transition-colors duration-200 ${
                  link ? 'group-hover:!text-[var(--brand-color)]' : ''
                }`}
                style={{
                  color: config?.element_color ? `${config.element_color}80` : 'var(--v3-black-secondary)', // 50% opacity for description
                  fontFamily: config?.font_name ? `${config.font_name}, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif` : undefined,
                  fontSize: config?.font_size ? `${Math.round(config.font_size * 0.9)}px` : undefined, // Slightly smaller for description
                }}
              >
                {description}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default CardWrapper
